import React from 'react';
import { Group } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
import { useGetTicketsAssignedToUserTeamsQuery } from '../../../../services/TicketService';
import { countActiveTickets } from '../../utils';
import MetricCard from '../MetricCard';

/**
 * MyTeamsTicketsCard - Displays count of tickets assigned to the current user's teams
 * Excludes closed/cancelled tickets to show only active team assignments
 */
const MyTeamsTicketsCard: React.FC = () => {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  
  // Get tickets assigned to user's teams
  const { data: myTeamsTickets = [], isLoading: myTeamsTicketsLoading } = useGetTicketsAssignedToUserTeamsQuery(
    { userId: account?.name || '' },
    { skip: !account?.name }
  );

  const myTeamsTicketsCount = countActiveTickets(myTeamsTickets);

  const handleClick = () => {
    if (account && account.name) {
      navigate(`/tickets/my-teams?userId=${encodeURIComponent(account.name)}`);
    } else {
      navigate('/tickets/my-teams');
    }
  };

  return (
    <MetricCard
      title="My Teams Tickets"
      value={myTeamsTicketsCount}
      icon={Group}
      color="#10b981"
      loading={myTeamsTicketsLoading}
      onClick={handleClick}
      subtitle="Assigned to my teams"
    />
  );
};

export default MyTeamsTicketsCard;